// src/services/init-app-configs.ts
import axiosUtil from '@/services/axios-helper'
import { AppConfig, useAppConfigStore } from '@/stores/app-config-store'
import { PublicClientApplication } from '@azure/msal-browser'

export const initializeAppConfigs = async (stores: any, msalInstance: PublicClientApplication) => {
  const response = await (await axiosUtil(msalInstance, { isAcquireAccessToken: false })).get('/api/app-configs-public')
  const appConfigs: AppConfig = response.data
  const configStore = useAppConfigStore(stores)
  configStore.loadAppConfigs(appConfigs)
}
